'use strict';

module.exports = [
// type
require('./Fraction'),

// construction function
require('./function/fraction')];


//////////////////
// WEBPACK FOOTER
// ./node_modules/mathjs/lib/type/fraction/index.js
// module id = mTGp
// module chunks = 0